import React, { Component } from "react";
import Srdicko from "../images/srdicko.jpg";

const News = () => {
  return (
    <>
      <div style={{textAlign: "center"}}>
        {/* <p className="news-desc">
						Vážení zákazníci,<br/>
						od <strong>12.05.2026</strong> do <strong>22.05.2026</strong> bude restaurace Mr.Le z technických důvodů zavřená.<br/> 
						Od <strong>23.05.2026</strong> se na Vás budeme opět těšit.<br/> 
						Děkujeme.
          {
					/* Vážení hosté, informujeme Vás, že z technických důvodů jsme nuceni přerušit prodej "Sushi" po dobu 12 dnů (20.05. - 01.06.2023).
          Omlouváme se za případné nepříjemnosti a děkujeme vám za pochopení. */}

          {/* <div /> */}
        {/* </p>  */}

        {/* <div>
          <img className="srdicko-img" src={Srdicko} alt="srdicko" />
        </div> */}
        {/* <div>
          <iframe
            className="video-fb"
            src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2F112500186825893%2Fvideos%2F142507617126488%2F&width=500&show_text=true&height=390&appId"
            width="500"
            height="390"
            scrolling="no"
            frameborder="0"
            allowTransparency="true"
            allow="encrypted-media"
            allowFullScreen="true"
          ></iframe>
        </div> */}
      </div>
    </>
  );
};

export default News;
